// import { tns } from 'tiny-slider/src/tiny-slider';
import Swiper, { Navigation, Scrollbar } from 'swiper';
import { loader } from '../utils/loader';

/**
 * Cards
 */
class Cards {
	/**
	 * Construct
	 *
	 * @description set state and cache elements.
	 */
	constructor(element) {
		/* Queries */
		this.element = element;

		if (!this.element) {
			return;
		}

		/* Initilize */
		this.init();
	}

	/**
	 * Init
	 *
	 * @description initialize.
	 */
	init() {
		// const styles = window.getComputedStyle(this.element);
		// const cols = styles.getPropertyValue('--grid-cols');
	
		const swiper = new Swiper(this.element, {
			modules: [Navigation, Scrollbar],
			freeMode: true,
			slidesPerView: 'auto',
			spaceBetween: 24,
			slidesPerGroup: 1,
			slidesPerGroupAuto: true,

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			// And if we need scrollbar
			scrollbar: {
				el: '.swiper-scrollbar',
			},
		});
	}
}

/**
 * Create Featured
 */
export const createCards = () => {
	loader('.rx-cards__grid.is-carousel', Cards);
};
